<!-- 联盟商品管理列表 -->
<template>
    <div id="goodSearch" class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-files" class="search-btn btn-primary" v-if="permission.uploadGoods" @click="gotoImportPage()">{{
                    permission.uploadGoods
                }}</el-button>
                <el-button size="small" icon="el-icon-edit-outline" class="search-btn btn-primary" v-if="permission.batchChangePrice" @click="gotoChangePricePage()">{{
                    permission.batchChangePrice
                }}</el-button>
                <el-button size="small" class="search-btn" type="primary" v-if="permission.batchOnSale" @click="batchAllOnSale()">一键上架</el-button>
                <el-button size="small" type="warning" class="search-btn" v-if="permission.batchOnSale" @click="batchOnSale()">{{ permission.batchOnSale }}</el-button>
                <el-button size="small" class="search-btn" type="warning" v-if="permission.batchSoldOut" @click="batchSoldOut()">{{ permission.batchSoldOut }}</el-button>
                <el-button size="small" class="search-btn" type="danger" v-if="permission.batchRemoveOut" @click="batchRemoveOut()">{{ permission.batchRemoveOut }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                <div class="search-name">适用车型</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                <div class="search-name">可售数</div>
                <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="> < =">
                    <el-option key=">=" label=">=" value=">="></el-option>
                    <el-option key=">" label=">" value=">"></el-option>
                    <el-option key="<=" label="<=" value="<="></el-option>
                    <el-option key="<" label="<" value="<"></el-option>
                    <el-option key="=" label="=" value="="></el-option>
                    <el-option key="!=" label="!=" value="!="></el-option>
                    <el-option key="between" label="区间" value="between"></el-option>
                </el-select>
                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent1"></el-input>
                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select
                        v-model="searchData.BrandName"
                        multiple
                        collapse-tags
                        filterable
                        clearable
                        size="small"
                        style="width: 100%"
                        @visible-change="brandVisibleChange($event)"
                    >
                        <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select size="small" style="width: 100%" v-model="searchData.Cate" multiple collapse-tags filterable clearable @visible-change="cateVisibleChange($event)">
                        <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name" v-if="isShowProject">合作项目</div>
                <el-select
                    class="search-item"
                     v-if="isShowProject"
                    v-model="searchData.ProjectId"
                    filterable
                    clearable
                    size="small"
                    @visible-change="projectVisibleChange"
                    placeholder="请选择合作项目"
                >
                    <el-option v-for="optionItem in projectList" :key="optionItem.ProjectId" :label="optionItem.ProjectName" :value="optionItem.ProjectId"> </el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border=""
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    @cell-dblclick="handleDBClick"
                    @sort-change="sortChange"
                >
                    <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                    <el-table-column min-width="180px" label="汽配编码" prop="APCode" sortable="custom" fixed="left" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="180px" label="汽配名称" prop="GoodName" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="250px" label="适用车型" prop="AutoSerise" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" label="可售数量" prop="Inventory" sortable="custom" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" label="销售总数" prop="SoldCount" sortable="custom" show-overflow-tooltip></el-table-column>
                    <el-table-column label="各价格段价格">
                        <el-table-column v-for="item in levelList" :key="item.LevelId" :label="item.LevelName" width="120px">
                            <template slot-scope="scope">
                                {{ scope.row.PriceLevelList | priceHandle(item.LevelId) }}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column min-width="80px'" label="单位" prop="Unit" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" label="汽配分类" prop="Cate" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" label="汽配品牌" prop="Brand" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" v-if="isShowProject" label="合作项目" prop="ProjectName" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="160px" label="更新时间" prop="UpdateTime" sortable="custom" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100px" label="更新人" prop="Updator" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="CreateTime" sortable="custom" min-width="160px" label="添加时间" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" width="200px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="setGoodsPrice(scope.row.UGoodsId)" v-if="permission.setPrice">{{ permission.setPrice }}</el-button>
                                <el-button type="text" size="mini" @click="setGoodsInvent(scope.row)" v-if="permission.setInvent && isShowInvenSet">{{
                                    permission.setInvent
                                }}</el-button>
                                <el-button type="text" size="mini" @click="onSale(scope.row.UGoodsId)" v-if="permission.onSale && scope.row.State == 0">{{
                                    permission.onSale
                                }}</el-button>
                                <el-button type="text" size="mini" style="color: orange" @click="soldOut(scope.row.UGoodsId)" v-if="permission.soldOut && scope.row.State == 1">{{
                                    permission.soldOut
                                }}</el-button>
                                <el-button type="text" size="mini" style="color: red" @click="removeOutGoods(scope.row.UGoodsId)" v-if="permission.removeOut">{{
                                    permission.removeOut
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <!--    查看库存    -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="设置联盟商品可售数量" :visible.sync="dialogInvenVisible" width="500px">
            <div class="dialog-content" v-if="dialogInvenVisible">
                <UnionGoodsInvenEdit ref="invenEdit" :uGoods="uGoods" @closeDialog="closeInvenDialog"></UnionGoodsInvenEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="设置联盟商品价格数据" :visible.sync="dialogPriceVisible" width="700px">
            <div class="dialog-content" v-if="dialogPriceVisible">
                <UnionGoodsPriceEdit ref="priceEdit" :uGoodsId="uGoodsId" @closeDialog="closePriceDialog"></UnionGoodsPriceEdit>
            </div>
        </el-dialog>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import UnionGoodsPriceEdit from '@/components/entpUnion/goodsManage/unionGoodsPriceEdit';
import UnionGoodsInvenEdit from '@/components/entpUnion/goodsManage/unionGoodsInvenEdit';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg,
        breadcrumb,
        UnionGoodsPriceEdit,
        UnionGoodsInvenEdit
    },
    data() {
        return {
            goodsMsg: {},
            multipleSelection: [],
            EntpTempGoodsIdEdit: '',
            brand: [],
            uGoods: {},
            uGoodsId: '',
            typeList1: [],
            dialogPriceVisible: false,
            dialogInvenVisible: false,
            APMsgVisible: false, //编辑
            isShowInvenSet: false,
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                ProjectId:'',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            },
            levelList: [],
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            saveLoading: false,
            batchAllTotalCount: 0,
            percentage: 0, //进度,
            page: 1, //页码
            fitCount: 0,
            unFitCount: 0,
            projectList:[],
            isShowProject:false
        };
    },
    created() {
        this.getLevelData();
    },
    mounted() {
        this.permission = this.$util.getUnionPermission('GoodsList');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getConfigByCodes();
        this.getTableData();
        this.getEditInventValue();
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        } else {
            this.$util.setEnterEvent(this, this.$route.fullPath);
        }
    },
    filters: {
        priceHandle(value, levelId) {
            let obj = value.find(item => item.LevelId === levelId);
            if (obj) return obj.Price;
            else return 0;
        }
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['hzxmxzset'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        gotoImportPage() {
            this.$router.push('/entpUnion/unionGoodsManage/unionGoodsImport');
        },
        gotoChangePricePage() {
            this.$router.push('/entpUnion/unionGoodsManage/unionGoodsChangePrice');
        },
        // 配件信息
        showAPMsgDialog(id) {
            this.EntpTempGoodsIdEdit = id;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        searchGoodsBrand() {
            if (this.brand.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        searchGoodsType() {
            if (this.typeList1.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList1 = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                ProjectId:'',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        // 获取数据
        getTableData() {
            if (this.searchData.Symbol) {
                //''空值isNan 也是返会false 所以要加parseInt做强制转换
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(parseInt(this.searchData.Invent1))) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(parseInt(this.searchData.Invent2))) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(parseInt(this.searchData.Invent1))) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            } else {
                this.searchData.Invent1 = 0;
                this.searchData.Invent2 = 0;
            }

            this.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/GetUnionGoodsForManage',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.tableData = [];
                        this.tableDataLength = 0;
                        return;
                    }
                    for (let i = 0; i < data.length; i++) {
                        data[i].AutoSeries = [];
                    }
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.EntpTempGoodsId) {
                this.showAPMsgDialog(event.EntpTempGoodsId);
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        getEditInventValue() {
            this.$util.getUnionConfig('tbqykc').then(res => {
                this.isShowInvenSet = !res.Result;
            });
        },
        onSale(uGoodsId) {
            if (uGoodsId) {
                this.$util
                    .axiosPost({
                        url: `/api/EntpUnionGoods/SubmitOnSaleGoods?uGoodsId=${uGoodsId}`
                    })
                    .then(res => {
                        this.$util.successMsg(res.errmsg);
                        this.getTableData();
                    })
                    .catch(() => {});
            } else this.$util.warningMsg('联盟商品数据异常，请刷新后重试');
        },
        soldOut(uGoodsId) {
            if (uGoodsId) {
                this.$util
                    .axiosPost({
                        url: `/api/EntpUnionGoods/SubmitSoldOutGoods?uGoodsId=${uGoodsId}`
                    })
                    .then(res => {
                        this.$util.successMsg(res.errmsg);
                        this.getTableData();
                    })
                    .catch(() => {});
            } else this.$util.warningMsg('联盟商品数据异常，请刷新后重试');
        },
        removeOutGoods(uGoodsId) {
            let that = this;
            if (uGoodsId) {
                that.$util.elConfirm({
                    content: '确定要移出该联盟商品吗?',
                    noMsg: true,
                    confirm() {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpUnionGoods/SubmitRemoveGoods?uGoodsId=${uGoodsId}`
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                that.getTableData();
                            })
                            .catch(() => {});
                    }
                });
            } else this.$util.warningMsg('联盟商品数据异常，请刷新后重试');
        },
        setGoodsPrice(uGoodsId) {
            if (uGoodsId) {
                this.uGoodsId = uGoodsId;
                this.dialogPriceVisible = true;
            } else this.$util.warningMsg('联盟商品数据异常，请刷新后重试');
        },
        setGoodsInvent(uGoods) {
            if (uGoods) {
                this.uGoods = uGoods;
                this.dialogInvenVisible = true;
            } else this.$util.warningMsg('联盟商品数据异常，请刷新后重试');
        },
        projectVisibleChange() {
            let that = this;
            if (that.projectList.length == 0) {
                that.$util.getAuthCoProjects().then(data => {
                    if (data) that.projectList = data;
                });
            }
        },
        closeInvenDialog(isEdit) {
            if (isEdit) this.getTableData();
            this.dialogInvenVisible = false;
        },
        closePriceDialog(isEdit) {
            if (isEdit) this.getTableData();
            this.dialogPriceVisible = false;
        },
        batchOnSale() {
            if (this.multipleSelection.length) {
                let ids = [];
                for (let index = 0; index < this.multipleSelection.length; index++) {
                    ids.push(this.multipleSelection[index].UGoodsId);
                }
                this.$util
                    .axiosPost({
                        url: `/api/EntpUnionGoods/BatchSubmitOnSaleGoods`,
                        data: { uGoodsIds: ids }
                    })
                    .then(res => {
                        this.$util.successMsg(res.errmsg);
                        this.getTableData();
                    })
                    .catch(() => {});
            } else this.$util.warningMsg('请选择要上架的商品');
        },
        batchAllOnSale() {
            let that = this;
            let unionId = that.$util.getLocalStorage('currentUnion');
            //一键上架
            that.$confirm('确定要一次性上架全部符合条件的商品吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(() => {
                    that.finishBOS();
                    that.saveLoading = true;
                    that.batchAllOnSaleGoods(unionId);
                })
                .catch(action => {});
        },
        batchAllOnSaleGoods(unionId) {
            let that = this;
            this.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/BatchAllOnSaleGoods',
                    data: {
                        UnionId: unionId,
                        Page: that.page
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (that.batchAllTotalCount == 0) {
                        that.batchAllTotalCount = res.data.totalCount;
                    }
                    that.fitCount += res.data.fitCount;
                    that.unFitCount += res.data.unFitCount;
                    let num = that.fitCount + that.unFitCount;
                    that.percentage = that.batchAllTotalCount <= 0 ? 0 : Math.round(Math.round((num / that.batchAllTotalCount) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    that.page++;
                    
                    if (res.data.totalCount == 0 || num + that.fitCount >= that.batchAllTotalCount) {
                        that.$util.successMsg(`成功上架符合条件联盟商品${that.fitCount}项；不符合条件${that.unFitCount}项。`);
                        that.saveLoading = false;
                        that.finishBOS();
                        that.getTableData();
                    } else {
                        that.batchAllOnSaleGoods(unionId);
                    }
                })
                .catch(() => {
                    that.saveLoading = false;
                    that.finishBOS();
                    this.getTableData();
                });
        },
        finishBOS() {
            let that = this;
            that.batchAllTotalCount = 0;
            that.percentage = 0;
            that.page = 1;
            that.fitCount = 0;
            that.unFitCount = 0;
        },
        batchSoldOut() {
            if (this.multipleSelection.length) {
                let ids = [];
                for (let index = 0; index < this.multipleSelection.length; index++) {
                    ids.push(this.multipleSelection[index].UGoodsId);
                }
                this.$util
                    .axiosPost({
                        url: `/api/EntpUnionGoods/BatchSubmitSoldOutGoods`,
                        data: { uGoodsIds: ids }
                    })
                    .then(res => {
                        this.$util.successMsg(res.errmsg);
                        this.getTableData();
                    })
                    .catch(() => {});
            } else this.$util.warningMsg('联盟商品数据异常，请刷新后重试');
        },
        batchRemoveOut() {
            let that = this;
            if (that.multipleSelection.length) {
                that.$util.elConfirm({
                    content: '确定要移出这些联盟商品吗?',
                    noMsg: true,
                    confirm() {
                        let ids = [];
                        for (let index = 0; index < that.multipleSelection.length; index++) {
                            ids.push(that.multipleSelection[index].UGoodsId);
                        }
                        that.$util
                            .axiosPost({
                                url: `/api/EntpUnionGoods/BatchSubmitRemoveGoods`,
                                data: { uGoodsIds: ids }
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                that.getTableData();
                            })
                            .catch(() => {});
                    }
                });
            } else that.$util.warningMsg('联盟商品数据异常，请刷新后重试');
        },
        getLevelData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetUnionPriceLevelList',
                    data: { UnionId: this.searchData.UnionId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    that.levelList = data;
                })
                .finally(() => {
                    that.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
</style>
